import React, { SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage, Fieldset, FormGroup, Hint, Legend, RadioButton } from '@ver-uds/uswds-react';

type FormValues = {
  mouSignatory: string;
};

type MouSignatoryRadioButtonsProps = {
  onChange: React.Dispatch<SetStateAction<string | undefined>>;
};

const MouSignatoryRadioButtons = ({ onChange }: MouSignatoryRadioButtonsProps): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { errors, register } = useFormContext<FormValues>();

  return (
    <FormGroup error={Boolean(errors.mouSignatory)}>
      <Fieldset>
        <Legend>
          Is this person the Signatory? <Hint>(required)</Hint>
        </Legend>
        {errors.mouSignatory ? (
          <ErrorMessage id="mou-signatory-error" className="padding-bottom-0">
            {errors.mouSignatory.message}
          </ErrorMessage>
        ) : null}
        <RadioButton
          id="mou-signatory-yes"
          label="Yes"
          aria-describedby={errors.mouSignatory ? 'mou-signatory-error' : undefined}
          name="mouSignatory"
          value="Yes"
          ref={register({
            required: {
              value: true,
              message: 'This field is required',
            },
          })}
          onChange={({ target }) => onChange(target.value)}
          required
        />
        <RadioButton
          id="mou-signatory-no"
          label="No"
          aria-describedby={errors.mouSignatory ? 'mou-signatory-error' : undefined}
          name="mouSignatory"
          value="No"
          ref={register({
            required: {
              value: true,
              message: 'This field is required',
            },
          })}
          onChange={({ target }) => onChange(target.value)}
          required
        />
      </Fieldset>
    </FormGroup>
  );
};

export default MouSignatoryRadioButtons;
